import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SwPush } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { SubscriptionService } from '../services/subscription.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-inscricao',
  templateUrl: './inscricao.component.html',
})
export class InscricaoComponent implements OnInit {

  readonly VAPID_PUBLIC_KEY = 'BBpjuua6sqzltFZbNG1UwXvG_3-GIpbht5KqD2XbWjoGZSDCnGj2p99b00nRbJsTLS4l0ffpMfGCssGGdBzGJks';
  private apiUrl = 'https://tc2pnyfvif.execute-api.sa-east-1.amazonaws.com/notify/notificar';
  // idSenha: string | null = null;
  mensagem: string = '';
  senhaID: string = '';
  notificacaoPermitida!: string;
  idSenha = '0'; // <<== Usar sempre isso
  guiche = '0'; // <<== Usar sempre isso
  idLocal: string = '';
  senhaNotificacao!: string;
  mensagemTitulo!: string;
  // mensagemTitulo: string = "Teste.";

  constructor(
    private route: ActivatedRoute,
    private swPush: SwPush,
    private http: HttpClient,
    private subscriptionService: SubscriptionService
  ) { }

  ngOnInit(): void {
    // debugger
    console.log('inicio Inscrição');
    console.log('InscricaoComponent carregado');
    this.mensagemTitulo = 'Inscrição para receber notificações.';
    this.notificacaoPermitida = Notification.permission;
    this.route.queryParams.subscribe(async params => {
      console.log('params', params);
      this.idSenha = params['ID'];
      this.idLocal = params['local'];
      this.senhaNotificacao = this.idSenha.split("_")[1];
      // console.log(this.idSenha)
      // console.log(this.idLocal)
      // console.log(this.senhaNotificacao)
      if (!this.idSenha) {
        this.mensagem = 'ID da senha não informado na URL.';
        return;
      }
      const jaRecarregou = localStorage.getItem('jaRecarregouNotificacao');
      if (!jaRecarregou) {
        navigator.serviceWorker.ready.then(() => {
          this.solicitarPermissaoNotificacao(this.idSenha, this.idLocal);
        });
        // await this.solicitarPermissaoNotificacao(this.idSenha, this.idLocal);
        console.log('entro no !jaRecarregou');
        localStorage.setItem('jaRecarregouNotificacao', 'true');
        console.log("se inscreveu para notificação")
        this.mensagemTitulo = 'Fique atento as notificações.';
        this.mensagem = 'Notificações configuradas com sucesso.';
        // this.senhaNotificacao = this.idSenha.split("_")[1];
        // window.location.reload();
      } else {
        console.log('entro no  else jaRecarregou');
        console.log('Já recarregou anteriormente. Não solicitando novamente.');
        this.mensagemTitulo = 'Fique atento as notificações.';
        localStorage.removeItem('jaRecarregouNotificacao');
        localStorage.setItem('recarregarPagina', 'true');
      }
      const recarregar = localStorage.getItem('recarregarPagina');
      if (recarregar) {
        console.log("Recarregou")
        window.location.reload();
        localStorage.removeItem('recarregarPagina');
      }
    });
    const recarregarPagina = localStorage.getItem('naoRecarregou');
  }

  async solicitarPermissaoNotificacao(id: string, local: string): Promise<void> {
    console.log('entrou no solicitarPermissaoNotificacao');

    console.log('Solicitando permissão de notificação...');
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      await this.inscreverNoPush(id, local);
      // window.location.reload();
    } else {
      await this.inscreverNoPush(id, local);
      // window.location.reload();
      this.mensagem = 'Permissão de notificação negada.';
    }
    console.log('Notification.permission => ', Notification.permission);
  }

  async inscreverNoPush(id: string, local: string): Promise<void> {
    console.log('entrou no inscreverNoPush');
    console.log('Chave pública:', this.VAPID_PUBLIC_KEY);
    try {
      console.log('entrou no try');
      const subscription = await this.swPush.requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY
      });
      console.log('Subscription criada:', subscription);
      await this.enviarSubscriptionParaServidor(id, local, subscription);
      console.log('Subscription enviada com sucesso.');
      const notResponse = await firstValueFrom(
        this.sendNotification(this.idSenha, "Inscrição realizada com sucesso! Fique atento às notificações.", this.idLocal)
      );
      console.log('Resposta da notificação:', notResponse);
    } catch (err) {
      console.error('Erro ao se inscrever no push:', err);
      this.mensagem = 'Erro ao se inscrever no push.';
    }
  }

  // async enviarSubscriptionParaServidor(id: string, local: string, subscription: PushSubscription): Promise<void> {
  //   console.log('entrou no enviarSubscriptionParaServidor');
  //   console.log("enviando subscription....")
  //   const payload = {
  //     ID: id,
  //     local: local,
  //     subscription: subscription
  //   };
  //   const body = {
  //     body: JSON.stringify(payload) // <<< AQUI! transforma o objeto em string
  //   };
  //   console.log('enviar POST');
  // await this.http.post('https://tc2pnyfvif.execute-api.sa-east-1.amazonaws.com/notify/salvar-subscription', body)
  // .subscribe(() => {
  //   console.log('Subscription enviada e salva com sucesso!');
  //   // debugger
  //   this.mensagem = 'Inscrição realizada com sucesso! Você pode minimizar esta aba.';
  //   localStorage.setItem('jaRecarregouNotificacao', 'true');
  //   this.mensagem = 'Notificações configuradas com sucesso.';
  //    this.sendNotification(this.idSenha, "Inscrição realizada com sucesso ! Fique atento as notificações.", this.idLocal).subscribe({
  //     next: (res) => {
  //       console.log('send notification dentro do else no jaRecarregou');
  //       console.log('Resposta da notificação:', res);
  //       // window.location.reload();
  //       // Aqui você pode fazer algo com o resultado
  //     },
  //     error: (err) => {
  //       console.error('Erro ao enviar notificação:', err);
  //     }
  //   });
  // }, (error) => {
  //   console.error('Erro ao enviar subscription', error);
  //   this.mensagem = 'Erro ao salvar a inscrição.';
  // });
  // }

  async enviarSubscriptionParaServidor(id: string, local: string, subscription: PushSubscription): Promise<void> {
    console.log('entrou no enviarSubscriptionParaServidor');
    const payload = {
      ID: id,
      local: local,
      subscription: subscription
    };
    const body = {
      body: JSON.stringify(payload)
    };
    try {
      const resposta = await firstValueFrom(
        this.http.post('https://tc2pnyfvif.execute-api.sa-east-1.amazonaws.com/notify/salvar-subscription', body)
      );
      console.log('Subscription enviada e salva com sucesso!', resposta);
      this.mensagem = 'Notificações configuradas com sucesso.';
      localStorage.setItem('jaRecarregouNotificacao', 'true');
    } catch (error) {
      console.error('Erro ao enviar subscription', error);
      this.mensagem = 'Erro ao salvar a inscrição.';
    }
  }

  sendNotification(ID: string, guiche: string, idLocal: string) {
    console.log("Entrou no send notificação");
    let msg = "Cliente chamado";
    const bodySend = {
      bodySend: JSON.stringify({
        ID,
        guiche,
        local: idLocal
      })
    };
    console.log(bodySend)
    return this.http.post(this.apiUrl, bodySend); // Requisição POST com o corpo
  }

}
